// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== НАПРАВЛЕНИЯ (ХАБЫ) ===== */
.destinations-section {
  margin-top: 20px;
}

.destinations-description {
  color: #6B7280;
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.destinations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.destination-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  padding: 12px 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.destination-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1E3A8A, #F59E0B, #1E3A8A);
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.destination-card:hover::before {
  transform: translateX(0);
}

.destination-card:hover {
  background: white;
  border-color: #F59E0B;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.destination-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #1E3A8A, #0F2B6E);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.destination-icon i {
  color: #F59E0B;
  font-size: 18px;
  transition: transform 0.3s ease;
}

.destination-card:hover .destination-icon {
  background: #F59E0B;
}

.destination-card:hover .destination-icon i {
  color: #1E3A8A;
  transform: scale(1.1);
}

.destination-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.destination-city {
  font-weight: 700;
  color: #1F2937;
  font-size: 16px;
  transition: color 0.3s ease;
}

.destination-card:hover .destination-city {
  color: #1E3A8A;
}

.destination-airport {
  font-size: 12px;
  color: #6B7280;
}

.destination-code {
  font-family: monospace;
  font-size: 10px;
  color: #9CA3AF;
  background: #F3F4F6;
  padding: 2px 6px;
  border-radius: 8px;
  display: inline-block;
  width: fit-content;
  transition: all 0.3s ease;
}

.destination-card:hover .destination-code {
  background: #EFF6FF;
  color: #1E3A8A;
}

.destination-arrow {
  width: 30px;
  height: 30px;
  background: #F3F4F6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.destination-arrow i {
  color: #9CA3AF;
  font-size: 12px;
  transition: all 0.3s ease;
}

.destination-card:hover .destination-arrow {
  background: #F59E0B;
  transform: translateX(5px);
}

.destination-card:hover .destination-arrow i {
  color: #1E3A8A;
}

/* Состояние загрузки */
.destinations-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #F9FAFB;
  border-radius: 16px;
  text-align: center;
}

.spinner-small {
  width: 40px;
  height: 40px;
  border: 3px solid #E5E7EB;
  border-top-color: #1E3A8A;
  border-right-color: #F59E0B;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Состояние ошибки */
.destinations-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #FEF2F2;
  border-radius: 16px;
  text-align: center;
  color: #B91C1C;
}

.destinations-error i {
  font-size: 40px;
  margin-bottom: 12px;
}

.retry-small {
  background: #1E3A8A;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 30px;
  font-size: 13px;
  cursor: pointer;
  margin-top: 12px;
  transition: all 0.3s ease;
}

.retry-small:hover {
  background: #F59E0B;
  color: #1E3A8A;
  transform: translateY(-2px);
}

/* Адаптивность */
@media (max-width: 768px) {
  .destinations-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .destination-card {
    padding: 10px 14px;
  }
  
  .destination-city {
    font-size: 15px;
  }
  
  .destination-airport {
    font-size: 11px;
  }
  
  .destination-icon {
    width: 36px;
    height: 36px;
  }
  
  .destination-icon i {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .destination-card {
    padding: 10px 12px;
  }
  
  .destination-city {
    font-size: 14px;
  }
  
  .destination-airport {
    font-size: 10px;
  }
  
  .destination-code {
    font-size: 9px;
  }
}`, "",{"version":3,"sources":["webpack://./react/components/hub.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* ===== НАПРАВЛЕНИЯ (ХАБЫ) ===== */\n.destinations-section {\n  margin-top: 20px;\n}\n\n.destinations-description {\n  color: #6B7280;\n  font-size: 14px;\n  margin-bottom: 20px;\n  line-height: 1.6;\n}\n\n.destinations-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 12px;\n}\n\n.destination-card {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background: #F9FAFB;\n  border: 1px solid #E5E7EB;\n  border-radius: 16px;\n  padding: 12px 16px;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.destination-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #1E3A8A, #F59E0B, #1E3A8A);\n  transform: translateX(-100%);\n  transition: transform 0.3s ease;\n}\n\n.destination-card:hover::before {\n  transform: translateX(0);\n}\n\n.destination-card:hover {\n  background: white;\n  border-color: #F59E0B;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n}\n\n.destination-icon {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #1E3A8A, #0F2B6E);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.destination-icon i {\n  color: #F59E0B;\n  font-size: 18px;\n  transition: transform 0.3s ease;\n}\n\n.destination-card:hover .destination-icon {\n  background: #F59E0B;\n}\n\n.destination-card:hover .destination-icon i {\n  color: #1E3A8A;\n  transform: scale(1.1);\n}\n\n.destination-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.destination-city {\n  font-weight: 700;\n  color: #1F2937;\n  font-size: 16px;\n  transition: color 0.3s ease;\n}\n\n.destination-card:hover .destination-city {\n  color: #1E3A8A;\n}\n\n.destination-airport {\n  font-size: 12px;\n  color: #6B7280;\n}\n\n.destination-code {\n  font-family: monospace;\n  font-size: 10px;\n  color: #9CA3AF;\n  background: #F3F4F6;\n  padding: 2px 6px;\n  border-radius: 8px;\n  display: inline-block;\n  width: fit-content;\n  transition: all 0.3s ease;\n}\n\n.destination-card:hover .destination-code {\n  background: #EFF6FF;\n  color: #1E3A8A;\n}\n\n.destination-arrow {\n  width: 30px;\n  height: 30px;\n  background: #F3F4F6;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.destination-arrow i {\n  color: #9CA3AF;\n  font-size: 12px;\n  transition: all 0.3s ease;\n}\n\n.destination-card:hover .destination-arrow {\n  background: #F59E0B;\n  transform: translateX(5px);\n}\n\n.destination-card:hover .destination-arrow i {\n  color: #1E3A8A;\n}\n\n/* Состояние загрузки */\n.destinations-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background: #F9FAFB;\n  border-radius: 16px;\n  text-align: center;\n}\n\n.spinner-small {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #E5E7EB;\n  border-top-color: #1E3A8A;\n  border-right-color: #F59E0B;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Состояние ошибки */\n.destinations-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background: #FEF2F2;\n  border-radius: 16px;\n  text-align: center;\n  color: #B91C1C;\n}\n\n.destinations-error i {\n  font-size: 40px;\n  margin-bottom: 12px;\n}\n\n.retry-small {\n  background: #1E3A8A;\n  color: white;\n  border: none;\n  padding: 8px 20px;\n  border-radius: 30px;\n  font-size: 13px;\n  cursor: pointer;\n  margin-top: 12px;\n  transition: all 0.3s ease;\n}\n\n.retry-small:hover {\n  background: #F59E0B;\n  color: #1E3A8A;\n  transform: translateY(-2px);\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .destinations-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n  \n  .destination-card {\n    padding: 10px 14px;\n  }\n  \n  .destination-city {\n    font-size: 15px;\n  }\n  \n  .destination-airport {\n    font-size: 11px;\n  }\n  \n  .destination-icon {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .destination-icon i {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .destination-card {\n    padding: 10px 12px;\n  }\n  \n  .destination-city {\n    font-size: 14px;\n  }\n  \n  .destination-airport {\n    font-size: 10px;\n  }\n  \n  .destination-code {\n    font-size: 9px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
